var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-text--ellipsisTip",on:{"mouseenter":_vm.mouseenter}},[_c('p',{ref:"text"},[_vm._t("default")],2),(_vm.isVisible)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }